module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content single-content"
  }, [_c('div', {
    staticClass: "textbox-bounds textbox-bounds-unbound-double"
  }, [_c('div', {
    staticClass: "textbox textbox-right"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('div', {
    staticClass: "auditionLogo"
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "src": "images/logo.png",
      "alt": "החצר"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "auditionLogoSubtitle"
  }, [_vm._v("הרכבים")])]), _vm._v(" "), _c('h3', [_vm._v("נעים להכיר!")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h3', [_vm._v("רוצים לדבר?")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("אנחנו כאן בשבילכם.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("במייל:")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#c7b7a5",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "mailto:OFFICE@YARDBANDS.COM"
    }
  }, [_vm._v("office@yardbands.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("טלפון:")]), _vm._v("\n\t\t\t\t\t\t\t 054-7737094. אם לא עונים - השאירו הודעת ווצאפ ונחזור אליכם בהקדם.\n\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("נתראה בקרוב")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://yardbands.com"
    }
  }, [_c('label', {
    staticClass: "login-next-button"
  }, [_vm._v("חזרה למסך הראשי")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d62581f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DetailsRhythm.vue
// module id = 101
// module chunks = 0